import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  UpdateEuTaxonomyCompanyActivityDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_COMPANY_ACTIVITY = "UPDATE_COMPANY_ACTIVITY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateCompanyActivityProps = {
  companyActivityId: string;
  data: UpdateEuTaxonomyCompanyActivityDto;
};

const updateCompanyActivity = async (
  props: UpdateCompanyActivityProps,
): Promise<void> => {
  const response =
    await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerUpdateEuTaxonomyCompanyActivity(
      props.companyActivityId,
      props.data,
    );

  return response.data;
};

export const useUpdateCompanyActivity = (
  user: UserProfileDto | null,
): {
  updateCompanyActivity: UseMutateFunction<
    void,
    unknown,
    UpdateCompanyActivityProps
  >;
  updateCompanyActivityEnabled: boolean;
  isSuccessUpdateCompanyActivity: boolean;
  isPendingUpdateCompanyActivity: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_UPDATE_COMPANY_ACTIVITY],
    mutationFn: enabled ? updateCompanyActivity : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY] });
    },
  });

  return {
    updateCompanyActivity: mutate,
    updateCompanyActivityEnabled: enabled,
    isSuccessUpdateCompanyActivity: isSuccess,
    isPendingUpdateCompanyActivity: isPending,
  };
};
